export default {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    x: 1700,
    xl: 1920,
  },
};
